import { entity } from "@mhmo91/ican";
import { firestore } from "@mhmo91/ican/firestore/binding";
import { z } from "zod";
import { GrantSchema } from "./grant.entity.ts";
import { type Actor, Id } from "./workspace.entity.ts";

// Event authority belongs beneath its organization membership; path identity
// prevents collisions between an event ID and an organization ID.
export const EventGrantSchema = GrantSchema.extend({
	kind: z.literal("event"),
	roleId: Id,
});
export type EventGrant = z.infer<typeof EventGrantSchema>;
export const EventGrant = entity<Actor>()({
	schema: EventGrantSchema,
	actions: ["read", "list"] as const,
})
	.pipe(({ can, pathVar }) => [
		can("read").when((_data, me) => me.uid.eq(pathVar("uid"))),
		can("list").when((_data, me) => me.uid.eq(pathVar("uid"))),
	])
	.adaptor(
		firestore({
			hierarchicalGrants: true,
			path: "users/{uid}/grants/{orgId}/events/{eventId}",
		}),
	);
